import React, {useEffect, useState} from 'react'
import {DESIGN_KEY_PREFIX} from "../../constants/design.constant";
import _ from 'lodash';

const ShowDesignVariantIndex = ({designVariantDetail}) => {
    const [variantIndex, setVariantIndex] = useState(null);

    useEffect(() => {
        if (designVariantDetail) {
            setVariantIndex(_.parseInt(_.replace(designVariantDetail.key, DESIGN_KEY_PREFIX.VARIANT + '-', '')))
        }
    }, [designVariantDetail]);

    return (
        <>
            #{variantIndex}
        </>
    )
}

export default ShowDesignVariantIndex
